<app-card [headerTitle]="'DASHBOARD.Varijabilne valute'" [border]="true" [padding]="false" [cardClass]="'height-equal'"
    [cardBodyClass]="'custom-input'">

    <div class="tab" [ngStyle]="{ 'display': (activeTab === 1 ? 'block' : 'none') }">
        <div class="row g-3">
            <div class="col-12 text-end">
                <div class="mt-1 ">
                    <a (click)="handleStep(1)" class="btn btn-primary">{{ "PROPERTIES.Dodaj" | translate }}<i
                            class="fa fa-plus"></i></a>
                </div>
            </div>
            <div class="pagination-space">
                <div class="common-fiwe">
                    <div class="table-responsive custom-scrollbar invoice-table">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>
                                        {{ "PROPERTIES.Datum" | translate }}
                                    </th>
                                    <th>
                                        {{ "PROPERTIES.Valuta" | translate }}
                                    </th>
                                    <th>
                                        {{ "PROPERTIES.Kurs valute" | translate }}
                                    </th>

                                    <th class="icons-column"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of valute; index as i">
                                    <td>
                                        <p>{{ item?.datum | date: "dd.MM.yyyy" }}</p>
                                    </td>

                                    <td>
                                        <p>{{ item?.valute?.valuta }}</p>
                                    </td>

                                    <td>
                                        <p>{{ item?.kurs | number : '1.2-5' }}</p>
                                    </td>

                                    <td class="icons-column">
                                        <div class="d-flex justify-content-center flex-nowrap">
                                            <div class="d-flex align-items-center px-2">
                                                <div class="d-flex justify-content-center align-items-center px-1">
                                                    <a placement="top" [ngbTooltip]="'FORME.Uredi' | translate"
                                                        class="btn btn-xs quare-white" (click)="edit(item)"><i
                                                            class="fa fa-edit fa-fw fa-lg text-primary"></i>
                                                    </a>
                                                </div>

                                                @if (setValuta) {
                                                <div class="d-flex justify-content-center align-items-center px-1">
                                                    <a placement="top" [ngbTooltip]="'FORME.Odaberi kurs' | translate"
                                                        class="btn btn-xs quare-white" (click)="useValuta(item)"> <i
                                                            class="fa fa-check-circle fa-fw fa-lg text-success"></i>
                                                    </a>
                                                </div>
                                                }

                                                <div class="d-flex justify-content-center align-items-center px-1">
                                                    <button placement="top" [ngbTooltip]="'FORME.Obrisi' | translate"
                                                        class="btn btn-xs quare-white"
                                                        (click)="openDeleteConfirmModal(item.sifra)">
                                                        <i class="fa fa-trash-o fa-fw fa-lg text-danger"></i>
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="tab" [ngStyle]="{ 'display': (activeTab === 2 ? 'block' : 'none') }">
        <form [formGroup]="form" (keyup.enter)="onSubmit()" (ngSubmit)="onSubmit()">
            <div class="common-form row g-3">
                <div class="col-4">
                    <label class="fw-bold">
                        {{ "PROPERTIES.Valuta" | translate }}
                    </label>
                    <ng-select class="col p-0 select-append" [items]="currencies" formControlName="valuta"
                        loadingText="Ucitavanje..." bindLabel="valuta" bindValue="sifra" [virtualScroll]="true"
                        [selectOnTab]="true" (change)="valutaChange()">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div>{{ item.valuta }}</div>
                        </ng-template>
                    </ng-select>
                </div>

                <div class="col-4">
                    <label class="fw-bold">
                        <span class="">{{ "PROPERTIES.Kurs valute" | translate }}</span>
                    </label>
                    <app-number-input-standalone formControlName="kurs"
                        [numberOfDecimals]="'5'"></app-number-input-standalone>
                </div>

                <div class="col-4">
                    <label class="fw-bold">
                        <span class="">{{ "PROPERTIES.Datum" | translate }}</span>
                    </label>
                    <input class="form-control" type="date" formControlName="datum" />
                </div>
            </div>
        </form>
        <div>
            <div class="text-end pt-3 mt-2">
                <button class="btn btn-secondary" type="button" (click)="handleStep(-1)">{{"PROPERTIES.Nazad" |
                    translate }}</button>
                <button class="btn btn-primary ms-2" type="button" (click)="onSubmit()">{{"FORME.Spremi" |
                    translate }}</button>
            </div>
        </div>
    </div>

    <div class="col-12 mt-4 text-end">
        <button class="btn btn-light btn-sm" type="button" (click)="forceCloseModal()">
            {{ "PROPERTIES.Zatvori" | translate }}
        </button>
    </div>

</app-card>